import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AuthUser from "../AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../Spinner";

import Swal from "sweetalert2";

import { startOfMonth, endOfMonth, format } from "date-fns";

const JustificarFaltaModal = ({ colaborador, onSubmitSuccess, falta }) => {
  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [justificada, setJustificada] = useState(0);

  const [ficheiros, setSelectedFile] = useState([]);

  const toggleLoading = (value) => {
    setLoading(value);
  }; 

  useEffect(() => {
    const currentDate = new Date();
    //setData(format(currentDate, "yyyy-MM-dd"));
    setData(falta?.data);
    setJustificada(falta?.justificada);
  }, [colaborador]);

  // REGISTO NOVO

  const justificar_falta = async () => {
    try {
      toggleLoading(true);

      await registar();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Show a error toast
        toast.error("Utilizador não autenticado.", {
          position: "top-right",
          autoClose: 3000, // Close the toast after 3 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      } else {
        // Show a error toast
        toast.error(
          "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado",
          {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          }
        );
      }
    } finally {
      toggleLoading(false);
    }
  };

  const registar = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("id", falta?.id);
      formData.append("justificada", justificada);

      const response = await http.post("/faltas/justificar", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setLoading(false);

      onSubmitSuccess(colaborador);

      Swal.fire({
        title: "INFORMAÇÃO",
        text: response?.data?.mensagem,
        type: "success",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    } catch (error) {
      console.error(error);

      toast.error(
        "Ocorreu um erro ao carregar o utilizador. Por favor, tente novamente mais tarde.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        }
      );
    }
  };

  const handleFileChange = (e) => {
    
    const newFile = e.target.files;

    // Lógica para processar a imagem, se necessário
    setSelectedFile(newFile);

    // Chamar uploadFiles() apenas se houver arquivos selecionados
    uploadFilesGeral(newFile);
  };

  const uploadFilesGeral = async (ficheiros) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("missao_id", getMissao()?.id);
      formData.append(
        "descricao",
        "Documento justificativa de falta " + falta?.data
      );
      formData.append("para_id", colaborador?.id);
      formData.append("tipo", 5); //Utilizador
      formData.append("falta_id", falta?.id);

      console.log("Falta ID");
      console.log(falta?.id);

      // Append each file separately
      if (ficheiros)
        for (let i = 0; i < ficheiros.length; i++) {
          formData.append("files[]", ficheiros[i]);
        }

      const response = await http.post("/criar-arquivo", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setLoading(false);

      onSubmitSuccess();

    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      {/* Personal Info Modal */}
      <div
        id="justificar_falta_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fa fa-calendar" /> justificação De Falta Para -{" "}
                {colaborador?.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="input-block mb-3 mb-3 form-focus focused">
                      <div>
                        <input
                          className="form-control"
                          type="date"
                          value={falta?.data}
                        />
                        <label className="focus-label">{t("Dia")}</label>
                      </div>
                    </div>

                    <div className="input-block mb-3 mb-3 form-focus focused">
                      <div>
                        <select
                          className="form-control select"
                          value={justificada}
                          onChange={(e) => setJustificada(e.target.value)}
                        >
                          <option value="0">Não justificada</option>
                          <option value="1">Sim, Justificada</option>
                        </select>
                        <label className="focus-label">{t("Justicada?")}</label>
                      </div>
                    </div>

                    <div className="input-block mb-3 mb-3 form-focus focused">
                      <div>
                        <input
                          type="file"
                          className="upload"
                          name="files[]"
                          onChange={(e) => handleFileChange(e)}
                          id="files_edit"
                          multiple="multiple"
                        />

                       
                      </div>
                    </div>

                    <div className="submit-section m-t-20 text-center">
                      <a
                        className="btn btn-primary submit-btn"
                        onClick={justificar_falta}
                      >
                        {t("Save")}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Personal Info Modal */}

      <ToastContainer />

      {loading ? (
        <>
          <Spinner></Spinner>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default JustificarFaltaModal;
